import client from './client';
import type { SelfCheckLog } from '../types';

/**
 * 自检 API 封装（全部在网页端运行，无需本地脚本）
 */

/** 最新一次自检结果 */
export async function fetchLatestSelfCheck(): Promise<SelfCheckLog | null> {
  const res = await client.get('/self-check/latest');
  return res.data;
}

/** 最近自检日志列表 */
export async function fetchSelfCheckLogs(limit: number = 20): Promise<SelfCheckLog[]> {
  const res = await client.get('/self-check/logs', { params: { limit } });
  return res.data;
}

/** 手动立即自检（绕过 60 秒节流） */
export async function runSelfCheckNow(): Promise<SelfCheckLog | null> {
  const res = await client.post('/self-check/run');
  return res.data;
}
